import useGoogleFonts from './useGoogleFonts'
export { mapLegacyWeightValue } from './buildGoogleWebfontUrl'
export default useGoogleFonts
